<template>
  <ExportTracksPage :tracks-list-route-name="tracksListRouteName" :export-tracks-function="exportTracksFunction" />
</template>

<script>

import TrackService from '@/modules/Apps/Services/TrackService'
import ExportTracksPage from "@/modules/Shared/Components/tracks/ExportTracksPage";

export default {
    name: 'app-tracks-export-form',
    components: {
      ExportTracksPage
    },
    data () {
      return {
        tracksListRouteName: 'export-app-tracks',
        exportTracksFunction: TrackService.exportTracks
      }
    }
}
</script>
